import type { TableSortingState } from '@ibsys/kit';

export const EXPERT_REPORT_PREFIX = 'expertReport_';

/** Префикс идентификатора колонки атрибута: id колонки — `attributes.{path}` */
export const ATTRIBUTE_COLUMN_PREFIX = 'attributes.';

/** Идентификатор колонки атрибута по его пути. */
export const attributeColumnId = (path: string): string => `${ATTRIBUTE_COLUMN_PREFIX}${path}`;

export const EMPTY_CELL = '';

/** Стандартные колонки экспертного заключения, всегда включаемые в панель управления колонками */
export const EXPERT_REPORT_STANDARD_COLUMNS = [
  'id',
  'rating',
  'startedAt',
  'finishedAt',
  'status',
  'verificationStatus',
  'summary',
] as const;

/** Идентификатор стандартной колонки заключения: `expertReport_{reportId}_{column}`, итог — `rating`. */
export const reportColumnId = (reportId: number, column: (typeof EXPERT_REPORT_STANDARD_COLUMNS)[number]): string =>
  `${EXPERT_REPORT_PREFIX}${reportId}_${column}`;

/** Идентификатор колонки результата блока заключения: `expertReport_{reportId}_block_{blockId}`. */
export const reportBlockColumnId = (reportId: number, blockId: number): string =>
  `${EXPERT_REPORT_PREFIX}${reportId}_block_${blockId}`;

/** Сортировка по умолчанию для списка диалогов: по ID убыванию (новые первыми) */
export const DEFAULT_DIALOG_SORTING: TableSortingState = [{ id: 'id', desc: true }];

/**
 * Предел «выбрать все» для массовых действий: запуск обработки и удаление получают только первые N
 * диалогов текущей отфильтрованной выборки (по действующей сортировке). Само усечение выборки
 * до предела пользователю не сообщается: подтверждение действия называет то, что действительно
 * ушло в работу, — а это и есть набранные первые N.
 */
export const MASS_RUN_SELECT_ALL_LIMIT = 500;

/**
 * Размер одной страницы при постраничном сборе id для «выбрать все». Поиск по диалогам отдаёт
 * не более 200 строк за запрос, поэтому предел «выбрать все» набирается страницами этого размера,
 * а не одним запросом на весь предел. Значение не должно превышать максимум страницы поиска.
 */
export const MASS_RUN_SEARCH_PAGE_SIZE = 200;

/**
 * Идентификаторы колонок поиска по содержимому диалога: «Релевантность» и колонки фрагмента
 * (реплики или комментария). При активном режиме поиска эта пара выводится в самом начале
 * таблицы и не сохраняется в пользовательский columnOrder, чтобы не «прилипать» после
 * деактивации режима.
 */
export const CONTENT_SEARCH_COLUMN_IDS = ['relevance', 'matchedPhraseSnippet', 'matchedCommentSnippet'] as const;

/** Проверка идентификатора на принадлежность к колонкам поиска по содержимому диалога */
export const isContentSearchColumnId = (id: string): boolean =>
  (CONTENT_SEARCH_COLUMN_IDS as readonly string[]).includes(id);
